import { useEffect } from 'react'
import { Button } from '@zoom/react-ui'
import { IconGoogleDrive, IconMSOneDrive } from '@zoom/icons-react'
import ConnectIcon from '../icons/Connect'
import { selectApp } from '../app/root'
import {
  useAppSelector,
  useSelectAuth,
  useSelectRunningContext,
} from '../hooks'
import ZoomIcon from '../icons/Zoom'

const ConnectToDrive = () => {
  // check if collaboration is in progress
  const runningContext = useSelectRunningContext()
  // assuming if collaboration is in progress then we are a receiver
  const userRole = runningContext === 'inCollaborate' ? 'receiver' : 'sender'
  const app = useAppSelector(selectApp)!
  const auth = useSelectAuth(app)
  const instructionTextForSender = `Sign into ${app} in your browser, then come back here to select a document.`
  const instructionTextForReceiver = `Sign into ${app} in your browser to join collaboration.`
  const instruction =
    userRole === 'sender'
      ? instructionTextForSender
      : instructionTextForReceiver

  useEffect(() => {
    if (auth?.authUrl) {
      zoomSdk.openUrl({ url: auth.authUrl })
    }
  }, [auth?.authUrl])

  const handleRefresh = () => {
    window.location.reload()
  }

  return (
    <div className='flex h-screen flex-col items-center justify-center px-4 md:px-10'>
      <div className='mb-4 flex items-center gap-4'>
        {app === 'Google' ? (
          <IconGoogleDrive className='text-[48px]' />
        ) : (
          <IconMSOneDrive className='text-[48px]' />
        )}
        <ConnectIcon />
        <ZoomIcon />
      </div>

      <p className='mb-2 text-base font-[590] text-[#323539]'>
        Connecting to your {app} account...
      </p>

      <p className='mb-6 text-center text-sm font-normal text-[#6E7680]'>
        {instruction}
      </p>

      <Button
        onClick={handleRefresh}
        type='secondary'
      >
        Refresh
      </Button>
    </div>
  )
}

export default ConnectToDrive
